module.exports = __webpack_public_path__ + "static/img/ucu-logo.48e9e0a7.png";